module.exports = __webpack_public_path__ + "img/map_mataro.4dbd84cb.png";